<template>
  <div class="menu-wrapper">
    <div class="menu">
      <header class="menu__header">
        <img alt="Sommer Madness" src="../assets/logo-blue.svg" class="menu__logo">
        <h1>MENU - KOLACJA</h1>
      </header>
      <section>
        <ol class="menu__list">
          <li>Kwiaty cukinii</li>
          <li>Pomidory</li>
          <li>Pasta Cavolo Nero</li>
          <li>Kalafior</li>
          <li>Granita</li>
          <li>Panna cotta</li>
        </ol>

        <h3 class="menu__price">179 zł* / os.</h3>

        <a href="#" class="button button--white button--disabled">Rezerwacja - (sold out)</a>

        <p class="disclaimer">
          * W cenę wliczona jest lampka wina lub kombuchy
        </p>
        <p><router-link class="menu__link" to="/">Wróć do strony głównej</router-link></p>
      </section>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'menuView',
};
</script>

<style lang="scss">
@import '../assets/mixins.scss';

.menu {
  padding: 67px 0;
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  text-align: center;
  color: #fff;

  @include text-paragraph;

  &__logo {
    width: 100%;
    max-width: 350px;
    display: block;
    margin: 0 auto 34px;
  }

  &__header {
    margin: 0 0 23px;
  }

  &__list {
    margin: 0 auto 23px;
    padding: 0;
    color: #fff;
    text-indent: 10px;
    font-size: 16px;
    list-style: none;
  }

  &__price {
    margin-bottom: 26px;
  }

  &__link {
    font-size: 13px;
    color: white;
    letter-spacing: -0.065px;
    text-decoration-line: underline;
  }
}

.hour {
  @include text-paragraph;
  margin: 0 0 14px;
}

.disclaimer {
  font-size: 11px;
  letter-spacing: -0.055px;
  margin: -10px 0 50px;
}

.date {
  position: relative;

  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    height: 1px;
    top: 50%;
    background: #352d89;
    z-index: 0;
  }

  span {
    letter-spacing: 0.9px;
    position: relative;
    display: inline-block;
    background: #fff;
    padding: 0 1.5em;
  }
}
</style>
